import styled from '@emotion/styled';
import { FORM_COLOR as C } from '@/pages/Seminar/components/form/formStyles';

/**
 * 치과 가입 '병원 인증' 단계의 결과 상자·버튼 — 병원 인증 단계와 '이미 가입된 치과' 안내(병원 인증·최종 가입)가 같이 쓴다.
 * 운영 가입 화면 형식(주 버튼 52·반경 14, 결과 상자 반경 12) 그대로.
 */

export const PrimaryButton = styled.button<{ inactive?: boolean }>`
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 14px;
    background: ${(p) => (p.inactive ? C.primaryDisabled : C.primary)};
    color: #fff;
    font-family: inherit;
    font-size: 16px;
    font-weight: 800;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:disabled {
        background: ${C.primaryDisabled};
        cursor: default;
    }
`;

/** 흰 바탕 테두리 보조 버튼 — 주 버튼과 같은 크기 */
export const OutlineButton = styled.button`
    width: 100%;
    height: 52px;
    border: 1px solid ${C.border};
    border-radius: 14px;
    background: #fff;
    color: ${C.sub};
    font-family: inherit;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

/** ok: 확인됨(연한 청록) / info: 다른 방법(흰 바탕) / warn: 이미 가입된 치과(청록 테두리 + 옅은 카드 바탕) */
export const ResultBox = styled.section<{ tone: 'ok' | 'info' | 'warn' }>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid ${(p) => (p.tone === 'info' ? C.border : C.primary)};
    background: ${(p) => (p.tone === 'ok' ? C.primarySoft : p.tone === 'warn' ? C.primaryCard : '#fff')};
`;

export const ResultTitle = styled.p`
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: ${C.text};
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        display: block;
        width: 22px;
        height: 22px;
        color: ${C.primary};
        flex-shrink: 0;
    }
`;

export const ResultText = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: ${C.sub};
    word-break: keep-all;
`;

/** 보조 선택 — 글자 버튼, 누르는 높이 44px */
export const SubMethodButton = styled.button`
    align-self: center;
    min-height: 44px;
    /* 한 줄이면 12 + 20 + 12 = 44px(누르는 높이) */
    padding: 12px 8px;
    border: none;
    background: none;
    color: ${C.primaryDeep};
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-decoration: underline;
    text-underline-offset: 3px;
    word-break: keep-all;
    text-align: center;
    cursor: pointer;
    display: inline-block;

    span {
        white-space: nowrap;
    }
`;
